<template>
  <div class="active-user-container">
    <div class="user-list">
      <b-avatar-group size="23px" overlap="0.35">
        <b-avatar
          v-for="(user, i) in getSocketUsers"
          :key="`${user.id}`"
          class="user-avatar"
          :class="{ 'in-active': !user.active }"
          :id="`${popoverID}-popover-target-${user.id}`"
        >
          <div
            v-if="!(user.id in getActiveUsersData)"
            class="user-avatar-image-container"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path
                d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
              />
            </svg>
          </div>
          <div
            v-else
            @mouseover="updateUserLastActiveTime(user.id, user.lastVisited)"
            class="user-initial-name"
          >
            {{ getSocketUserName(user.id) }}
          </div>
          <b-popover
            :target="`${popoverID}-popover-target-${user.id}`"
            triggers="hover"
            placement="bottom"
            custom-class="active-users-popover"
          >
            <h6 class="user-name">
              {{ getActiveUsersData[user.id]?.name || 'User' }}
            </h6>
            <div class="user-details">
              <p v-if="user.active" class="user-active">Aktiv</p>
              <p v-if="!user.active">Zuletzt Aktiv</p>
              <span v-if="!user.active"> {{ usersTime[user.id] }}</span>
            </div>
          </b-popover>
        </b-avatar>
      </b-avatar-group>
    </div>
    <div
      :id="`${popoverID}-popover-count`"
      v-if="getMoreSocketUsers.length > 0"
      class="users-count"
      @mouseover="isMoreActiveUserVisible = true"
      @mouseleave="isMoreActiveUserVisible = false"
    >
      +{{ getMoreSocketUsers.length }}
    </div>
    <b-popover
      v-if="isMoreActiveUserVisible && getMoreSocketUsers.length > 0"
      :target="`${popoverID}-popover-count`"
      triggers="hover"
      placement="bottom"
      custom-class="more-active-users-popover active-users-popover"
    >
      <div class="more-active-users-container">
        <h6>Zuletzt Aktiv</h6>
        <div>
          <div
            v-for="user in getMoreSocketUsers"
            :key="user.id"
            class="more-active-users-details"
          >
            <p>{{ getActiveUsersData[user.id]?.name }}</p>
            <span v-if="user.active" class="user-active">Active</span>
            <span v-if="!user.active">{{
              getLastActiveTime(user.lastVisited)
            }}</span>
          </div>
        </div>
      </div>
    </b-popover>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getElapsedTime, getUserInitials } from '../../utils/helpers';
export default {
  name: 'AvatarGroup',
  data() {
    return {
      usersTime: {},
      isMoreActiveUserVisible: false,
    };
  },
  props: {
    popoverID: {
      type: String,
      required: true,
    },
    currentItem: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateUserLastActiveTime(id, time) {
      this.$set(this.usersTime, id, getElapsedTime(time));
    },
    getSocketUserName(userID) {
      if (this.getActiveUsersData[userID]?.name) {
        return getUserInitials(this.getActiveUsersData[userID]?.name);
      }
      return 'US';
    },
    getLastActiveTime(lastVisitedTimestamp) {
      return getElapsedTime(lastVisitedTimestamp);
    },
  },
  computed: {
    ...mapGetters({
      getUserId: 'getUserId',
      getActiveUsersData: 'getActiveUsersData',
    }),
    getSortedSocketUsers() {
      return [];
    },
    getSocketUsers() {
      return this.getSortedSocketUsers.slice(
        -3,
        this.getSortedSocketUsers.length
      );
    },
    getMoreSocketUsers() {
      if (this.getSortedSocketUsers.length <= 3) {
        return [];
      }
      return this.getSortedSocketUsers.slice(0, -3).reverse();
    },
  },
};
</script>
<style scoped>
.active-user-container {
  display: flex;
  align-items: center;
  min-width: 53px;
  max-width: max-content;
  justify-content: flex-end;
  padding: 0px !important;
  position: absolute;
  left: -5px;
  top: 5px;
  margin: 0;
  transform: rotate(90deg);
  transform-origin: top left;
}

.active-user-container .user-list {
  margin-right: 5px;
  display: block !important;
  width: 100%;
}

.active-user-container .users-count {
  font-size: 14px;
  line-height: 1.2;
  cursor: pointer;
  rotate: 270deg;
}

.more-active-users-container .more-active-users-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2px 0;
}
.more-active-users-container .more-active-users-details p {
  font-size: 14px;
  line-height: 1.2;
  margin: 0;
  text-transform: capitalize;
  text-overflow: ellipsis;
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
}
.more-active-users-container .more-active-users-details span {
  font-size: 12px;
  line-height: 1.2;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
}
.more-active-users-container h6 {
  font-size: 16px;
  font-family: 'Aktiv Grotesk';
}

.user-name {
  text-transform: capitalize;
}

.user-initial-name {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
}

.user-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
}

.user-details .user-active,
.more-active-users-container .more-active-users-details .user-active {
  color: #69ff8b !important;
  font-weight: 500;
}
.user-details p,
.user-details span {
  margin: 0;
  font-size: 12px;
  line-height: 1.2;
}
.user-details span {
  color: #ffffff80;
}

.b-avatar-group ::v-deep .b-avatar-group-inner {
  flex-direction: row;
  flex-wrap: nowrap;
}
.b-avatar-group .b-avatar-group-inner .b-avatar {
  background-color: white !important;
  text-transform: uppercase;
  cursor: pointer;
  filter: drop-shadow(0 0.1px 5px rgba(0, 0, 0, 0.6));
  opacity: 1;
  border: none !important;
  color: #bbb;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Aktiv Grotesk';
  position: relative;
  z-index: 999;
}

.b-avatar-group .b-avatar-group-inner .b-avatar.in-active {
  filter: drop-shadow(0 0.1px 3px rgba(0, 0, 0, 0.1));
  z-index: 1;
}

.b-avatar-group .b-avatar-group-inner .b-avatar ::v-deep .b-avatar-custom {
  position: relative;
  rotate: 270deg;
}

.b-avatar-group .b-avatar-group-inner .b-avatar:hover {
  filter: drop-shadow(0 0.1px 5px rgba(0, 0, 0, 0.6));
  z-index: 9999;
}

.user-avatar-image-container svg {
  width: 12px;
  fill: #777777;
}
</style>
